module.exports = __webpack_public_path__ + "static/media/arrow.070b904c.svg";